import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { MaskPatterns } from 'src/app/constants/masks';

export class FormValidationService {

	static formHasAtLeastOneValue(form: FormGroup): ValidationErrors {
		return Object.keys(form.value).some(key => !!form.value[key]) ?
			null :
			{ atLeastOneRequired: 'At least one should be selected' };
	}

	static formArrayRequiresCheckboxChecked(checkBoxProperyName: string, minRequired = 1): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			let l_Selected = 0;

			if (control instanceof FormArray) {
				const fac: FormArray = control as FormArray
				fac.controls.map(g => {
					if(g.get(checkBoxProperyName).value)
						l_Selected++;
				});
			} else if (control.value instanceof Array) {
				control.value.map(cv => {
					for (const prop in cv) {
						if (prop === checkBoxProperyName) {
							if (cv[prop]) {
								l_Selected++;
							}
						}
					}
				});
			}

			return l_Selected >= minRequired ? null : { required: true };
		};
	}

	static formArrayRequiresOneBooleanTrue(properyNames: string[], minRequired = 1): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			let l_Selected = 0;

			if (control.value instanceof Array) {
				control.value.map(cv => {
					for (const prop in cv) {
						properyNames.map(properyName => {
							if (prop === properyName) {
								if (cv[prop]) {
									l_Selected++;
								}
							}
						})
						
					}
				});
			}

			return l_Selected >= minRequired ? null : { required: true };
		};
	}

	static validDropdown(controlName: string): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (control.value <= 0)
				return { 'invalidSelection': `Selection for ${controlName} is Required` };
			return null;
		};
	}

	static validMatchingValue(otherControlName: string, OnlyUpdateOtherControlValidaton?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;
			if (!value)
				return { notMatching: true }

			const isValid = !!control.parent &&
				!!control.parent.value &&
				value === control.parent.get(otherControlName).value;

			if (OnlyUpdateOtherControlValidaton) {
				if (isValid)
					control.parent.get(otherControlName).setErrors(null);
				else
					control.parent.get(otherControlName).setErrors({ notMatching: true });

				return null;
			}

			return isValid ? null : { notMatching: true };
		}
	}

	static validShortDate(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'date': 'Date is required.' } : null;
			}

			if (isRequired && !MaskPatterns.DATE_SHORT.test(control.value)) {
				return { 'date': 'Date is sinvalid.' };
			}

			return null;
		};
	}

	static validShortDateCCExpire(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'date': 'Date is required.' } : null;
			}

			if (isRequired && !MaskPatterns.DATE_SHORT_CCEXPIRE.test(control.value)) {
				return { 'date': 'Date is sinvalid.' };
			}

			return null;
		};
	}

	static validMaterialDate(isRequired: boolean, AllowAnyDate?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'date': 'Date is required.' } : null;
			}

			const controlYear = new Date(control.value).getFullYear();
			
			if (!AllowAnyDate) {
				const currentDate = new Date();

				if (currentDate !== null && new Date(control.value).getTime() > currentDate.getTime())
					return { 'date': 'Date is invalid.' };
				else if (controlYear < 1900)
					return { 'date': 'Date is invalid.' };
			} else {
				if (controlYear < 1900) 
					return { 'date': 'Date is invalid.' };
				else if (controlYear > 2050)
					return { 'date': 'Date is invalid.' };
			}

			return null;
		};
	}

	static validMaterialDateByDaysFrame(isRequired: boolean, days: number): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'date': 'Date is required.' } : null;
			}

			const contolMonth = new Date(control.value);
			const minDate = new Date(new Date().getDate() - days);
			const maxDate = new Date(new Date().getDate() + days);

			if (contolMonth.getTime() < minDate.getTime()) {
				return { 'date': 'Date is invalid.' };
			} else if (contolMonth.getTime() > maxDate.getTime()) {
				return { 'date': 'Date is invalid.' };
			}

			return null;
		};
	}

	static validnumber(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;
			if (!value)
				return isRequired ? { notMatching: true } : null;

			return value > 0 ? null : {'Invalid Number': 'Number is not greather than zero'};
		}
	}

	static validCurrency(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;
			if (!value)
				return isRequired ? { notMatching: true } : null;

			return !!control.parent &&
				!!control.parent.value
				? null
				: { notMatching: true };
		}
	}

	static validEmail(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'incorrectMailFormat': 'Email is required.' } : null;
			}

			if (control.value.length < 4 ||
				control.value.indexOf('.') === -1 ||
				control.value.split('.')[1].length < 1 ||
				!MaskPatterns.EMAIL.test(control.value)) {
				return { 'incorrectMailFormat': 'Please enter a valid email.' };
			}

			return null;
		};
	}

	static validEmailConfirm(emailControlName: string, confirmEmailControlName: string): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const emailValue = control.get(emailControlName).value;
			const confirmEmailValue = control.get(confirmEmailControlName).value;

			if (!confirmEmailValue) {
				control.get(confirmEmailControlName).setErrors({ 'incorrectMailFormat': 'Confirm Email is required.' });
			} else if (emailValue !== confirmEmailValue) {
				control.get(confirmEmailControlName).setErrors({ 'emailMismatched': 'Email fields do not match.' });
			} else {
				control.get(confirmEmailControlName).setErrors(null);
			}

			return null;
		};
	}

	static validsingleAlphaNumeric(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'invalidsingleAlphaNumeric': 'SSN is required.' } : null;
			}

			if (!control.value.match(MaskPatterns.SINGLE_ALPHANUMERIC)) {
				return { 'invalidsingleAlphaNumeric': 'SSN is invalid.' };;
			}

			return null;
		};
	}

	static validSSN(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'invalidFullSSN': 'SSN is required.' } : null;
			}

			if (control.value.replace(MaskPatterns.REMOVE_SSN_MASK, '').length === 9 &&
				control.value.match(MaskPatterns.LAST_4_SSN_MASK)) {
				return null;
			}

			const mutable = control.value.replace(MaskPatterns.NON_DECIMAL_DIGITS, '');
			if (!MaskPatterns.FULL_SSN.test(mutable)) {
				return { 'invalidFullSSN': 'SSN is invalid.' };
			}

			return null;
		};
	}

	static validLast4SSN(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value)
				return isRequired ? { 'invalidLast4SSN': 'SSN is required.' } : null;

			if (control.value.length < 4 || control.value.length == 0)
				return { 'invalidLast4SSN': 'SSN is required.' };

			return null;
		};
	}

	static validPhoneNumber(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'invalidPhone': 'Phone number is required.' } : null;
			}
			const strippedValue = control.value.replace(MaskPatterns.NON_DECIMAL_DIGITS, '');
			if (!MaskPatterns.PHONE.test(strippedValue)) {
				return { 'invalidPhone': 'Phone number is invalid.' };
			}

			return null;
		};
	}

	static validPhoneNumberConfirm(phoneControlName: string, confirmPhoneControlName: string): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const phoneValue = control.get(phoneControlName).value;
			const confirmPhoneValue = control.get(confirmPhoneControlName).value;

			if (phoneValue !== confirmPhoneValue) {
				control.get(confirmPhoneControlName).setErrors({ 'phoneMismatched': 'Phone Number fields do not match.' });
			}

			return null;
		};
	}

	static validZipcode(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value) {
				return isRequired ? { 'noValidZip': 'Zip Code is required.' } : null;
			}
			if (!MaskPatterns.ZIPCODE.test(control.value)) {
				return { 'noValidZip': 'Zip Code is invalid.' };
			}

			return null;
		};
	}

	static validPassword(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			const value = control.value;
			let l_ErrorMessage: ValidationErrors = {};

			if (!value || value.length < 8)
				l_ErrorMessage = { ...l_ErrorMessage, ...{ 'requireMin': 'Password must be a minimum of 8 characters.' } };

			if (!value || value.length > 20)
				l_ErrorMessage = { ...l_ErrorMessage, ...{ 'requireMax': 'Password cannot exceed 20 characters.' } };

			if (!value || !MaskPatterns.NUMERIC_VALUES.test(value))
				l_ErrorMessage = { ...l_ErrorMessage, ...{ 'requireDigit': 'Passowrd must container at least one number.' } };

			if (!value || !MaskPatterns.SPECIAL_CHARACTERS.test(value))
				l_ErrorMessage = { ...l_ErrorMessage, ...{ 'requireSpecial': 'Passowrd must container at least one special character.' } };

			return l_ErrorMessage
		};
	}

	static validCardCode(isRequired?: boolean): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			if (!control.value)
				return isRequired ? { 'noValidCardCode': 'Card Code is required.' } : null;

			if (control.value.toString().length < 3 || control.value.toString().length > 4)
				return { 'noValidCardCode': 'Length must be between 3 or 4' };

			if (!MaskPatterns.NUMERIC_VALUES.test(control.value))
				return { 'noValidCardCode': 'Card Code is invalid.' };

			return null;
		};
	}
}